export default __webpack_public_path__ + "static/media/Sinergia_BannerRegistro.6f3afe9e.jpg";